import punycode from "punycode/";

export function normalizeEmail(raw) {
  if (!raw) return null;

  // Trim + Unicode normalize
  let email = raw.trim().normalize("NFKC");

  const at = email.lastIndexOf("@");
  if (at <= 0 || at === email.length - 1) return null;

  let local = email.slice(0, at);
  let domain = email.slice(at + 1);

  // Lowercase domain & IDNA
  domain = punycode.toASCII(domain.toLowerCase());

  // Gmail canonicalization
  if (domain === "googlemail.com") domain = "gmail.com";
  if (domain === "gmail.com") {
    local = local.toLowerCase();
    const plus = local.indexOf("+");
    if (plus !== -1) local = local.slice(0, plus);
    local = local.replace(/\./g, "");
  } else {
    // Conservative for non-Gmail providers
    local = local.toLowerCase();
  }

  return `${local}@${domain}`;
}
